import { Alert, Button, Col, Form, Input, Row } from 'antd';
import { useHistory } from 'react-router';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { APIResponseCode, Constants } from 'common/constants';
import { ResetPasswordBusiness } from '../business/AccountBusiness';
import { PATHS } from '@routing/routes';
import { AccountSelector } from '../store/AccountSelector';
import { AccountActions } from '../store/AccountSlice';
export const ResetPassword = () => {
  const [form] = Form.useForm();
  const history = useHistory();
  const accountState = useSelector(AccountSelector);
  const dispatch = useDispatch();
  const onFinish = async (values: any) => {
    dispatch(AccountActions.resetState());
    const response = await dispatch(ResetPasswordBusiness(values.Email));

    if (response.toString() === APIResponseCode.SUCCESS && accountState.IsValidEmailResetPassword) {
      history.push(PATHS.ResetPasswordSendCode.path);
    }
  };

  const onChange = () => {
    dispatch(AccountActions.SetResetPasswordEmail(''));
    dispatch(AccountActions.SetIsValidEmailResetPassword(true));
  };

  return (
    <div className="App">
      <Row justify="center" align="middle">
        <h4>Reset password</h4>
      </Row>

      <Form name="senderForm" onFinish={onFinish} layout="vertical" form={form}>
        <>
          <Row justify="center" align="middle">
            <Col xs={24} sm={20} md={12} lg={8} xl={8}>
              <br />
              <Form.Item
                label="Email"
                name="Email"
                rules={[
                  { required: true, message: Constants.REQUIRED_FIELD },
                  {
                    pattern: Constants.EMAIL_REGEX_INPUT,
                    message: 'Please enter a valid email address.',
                  },
                ]}
              >
                <Input maxLength={150} size="large" onChange={onChange} />
              </Form.Item>
              {!accountState.IsValidEmailResetPassword && (
                <>
                  <Alert
                    message="We couldn't find an account with this email. Please check and try again."
                    type="error"
                    showIcon
                  />
                  <br />
                </>
              )}
              <div>
                <Button className="nextSenderBtn" size="large" type="primary" htmlType="submit">
                  {Constants.BTN_NEXT}
                </Button>
                <Button
                  className="prevSenderBtn "
                  size="large"
                  type="default"
                  onClick={() => history.push(PATHS.Login.path)}
                >
                  {Constants.BTN_BACK}
                </Button>
              </div>
            </Col>
          </Row>
        </>

        <br />
        <Row justify="center" align="middle">
          <Col>
            <Link to={PATHS.Login.path} className="normal-font">
              Back to Log in
            </Link>
          </Col>
        </Row>
      </Form>
    </div>
  );
};
